<template>
  <v-col
    v-if="meetingSlots && meetingSlots.length > 1"
    :class="isEmbedded ? 'px-0 slotList pt-0 pb-9' : 'slotList'"

  >
    <v-row
      :class="isEmbedded ? 'ml-0' : 'ml-2'"
      wrap
      no-gutters
      justify-center
      class="slotList__timezone">
      <!-- <v-col
        cols="12"
        md="12">
        <h3
          :class="!isEmbedded ? 'text-left title black--text mb-4' : 'body-2 my-2 font-weight-bold'">
          {{ $t('home.selectSlot') }}
        </h3>
      </v-col> -->
      <v-col
        cols="12">
        <v-row
          class="align-baseline wrap mx-2 pt-2"
          no-gutters>

          <v-col
            cols="12"
            lg="4"
            md="5"
            sm="12"
            xs="12"
          >
            <v-autocomplete
              v-model="selectedMeetingType.timezone"
              :items="timeZones"
              :label="this.$t('home.timezone')"
              :class="isEmbedded ? 'pa-3 noTextDetails body-1' : 'body-1 my-0 py-0'"
              item-value="tz"
              item-text="tzDisplay"
              append-icon="arrow_drop_down"
              @change="timezoneChange">
              <template
                slot="selection"
                slot-scope="data">
                <span>{{ data.item.tzDisplay }}</span>
                <span
                  class="body-1 pl-2 grey--text">{{ isTz12H(selectedMeetingType.timezone) ? data.item.hourH12 : data.item.hour }}</span>
              </template>
              <template
                slot="item"
                slot-scope="data">
                <span>{{ data.item.tzDisplay }}</span>
                <v-spacer/>
                <span
                  class="body-1 grey--text">{{ isTz12H(selectedMeetingType.timezone) ? data.item.hourH12 : data.item.hour }}</span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col
            :class="isEmbedded ? '' : 'headline'"
            cols="12"
            lg="8"
            md="7"
            sm="12"
            xs="12"
            class="text-right">
            {{ currentMonth }}
            <v-btn
              :disabled="startDaysList <= 0"
              :class="isEmbedded ? 'smallerBtn' : ''"
              fab
              small
              depressed
              class="mr-1 ml-3 white"
              @click.native="previousSlots()">
              <v-icon
                class="mr-1 font-weight-bold"
                small>chevron_left</v-icon>
            </v-btn>
            <v-btn
              :disabled="startDaysList + numberSlotToDisplay >= daysList.length"
              :class="isEmbedded ? 'smallerBtn' : ''"
              fab
              small
              depressed
              class="white"
              @click.native="nextSlots()">
              <v-icon
                class="font-weight-bold"
                small>chevron_right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row
      no-gutters
      class="slotList__DayList mt-3">
      <template
        v-for="(day, index) in currentDaysList"
      >
        <v-col
          :key="index"
          :class="weekEndDays.includes(day.date.toLocaleDateString('en-US', { weekday: 'short' })) ? 'slotList__DayList-column__weekEndDay' : 'slotList__DayList-column'"
          xs="6"
          sm="4"
          md="3"
          lg="2">
          <v-row
            column
            class="px-3"
            no-gutters
            no-wrap>
            <v-col
              sm="12"
              mb-1
              cols="12">
              <v-row
                no-gutters
                wrap>
                <v-col
                  cols="12"
                  class="text-center body-1 font-weight-medium slotList__DayList-column-day">
                  {{ day.date.toLocaleDateString('en-US', { weekday: 'short' }) }}

                  <span
                    :class="day.date.isToday ? 'slotList__DayList-date--today' : '' "
                    class="ml-2 body-2 slotList__DayList-column-date grey--text text--darken-2">{{ day.date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) }}
                    <!--sup>{{ getNth(day.date.getDate()) }}</sup-->
                  </span>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              v-for="(possibleTime, slotIndex) in currentPossibleTimes"
              :key="slotIndex"
              cols="12"
              xs="12"
            >
              <!-- Slot to Reschedule -->
              <v-row
                v-if="isRescheduledSlot(day.date, possibleTime)"
                my-1
                no-gutters
                class="my-1">
                <v-col
                  xs="12"
                  cols="12">
                  <v-btn
                    outlined
                    large
                    class="slotList__DayList-column--slotReschedule slotList__DayList-column--slot font-weight-regular">
                    {{ formatHour(slotToReschedule, selectedMeetingType.timezone) }}-{{ formatHour(slotToRescheduleEnd, selectedMeetingType.timezone, true) }}
                  </v-btn>
                </v-col>
              </v-row>
              <!-- Slot -->
              <v-row
                v-else-if="daySlotStartTime(day.slots, possibleTime).length > 0"
                my-1
                no-gutters
                class="my-1 flex-no-wrap"
              >
                <v-col
                  xs="12"
                  cols="12">
                  <v-btn
                    :loading="isSaving && daySlotStartTime(day.slots, possibleTime)[0] === slotSaving"
                    color="primary"
                    ripple
                    outlined
                    large
                    class="slotList__DayList-column--slot font-weight-regular"
                    @click.native="goToSlot(daySlotStartTime(day.slots, possibleTime)[0])">
                    <template v-if="isTz12H(selectedMeetingType.timezone)">
                      {{ daySlotStartTime(day.slots, possibleTime)[0].startH12 }}-{{ daySlotStartTime(day.slots, possibleTime)[0].endH12 }}
                    </template>
                    <template v-else>
                      {{ daySlotStartTime(day.slots, possibleTime)[0].start }}-{{ daySlotStartTime(day.slots, possibleTime)[0].end }}
                    </template>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <!-- No Slot -->
            <template v-for="index in currentMaxNbSlots-day.slots.length">
              <v-col
                :key="index"
                cols="12"
                xs="12">
                <v-row
                  :key="index"
                  my-1
                  no-gutters
                  class="my-1">
                  <v-btn
                    depressed
                    large
                    style="width:100%"
                    class="grey--text darken--2 slotList__DayList--block"
                  />
                </v-row>
              </v-col>
            </template>
          </v-row>
        </v-col>
      </template>
      <template v-if="currentDaysList.length < numberSlotToDisplay">
        <v-col
          :xs="6 * (numberSlotToDisplay - currentDaysList.length)"
          :sm="4 * (numberSlotToDisplay - currentDaysList.length)"
          :md="3 * (numberSlotToDisplay - currentDaysList.length)"
          :lg="2 * (numberSlotToDisplay - currentDaysList.length)">
          <v-row
            class="px-1"
            no-gutters>

            <template v-for="(filler, index) in dayFiller">
              <v-row
                v-if="currentDaysList.length + index < numberSlotToDisplay"
                :key="'filler'+index"
                no-gutters >
                <v-col
                  cols="12"
                  class="text-center body-1 slotList__DayList-column-day">
                  {{ filler.toLocaleDateString('en-US', { weekday: 'short' }) }}
                  <span
                    :class="filler.isToday ? 'slotList__DayList-date--today' : '' "
                    class="ml-2 body-2 slotList__DayList-column-date grey--text darken-2">{{ filler.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) }}
                    <!--sup>{{ getNth(filler.getDate()) }}</sup-->
                  </span>
                </v-col>
              </v-row>
            </template>
          </v-row>
          <v-row
            column
            no-gutters
            wrap
            class="slotList__DayList--filler pa-3 ma-1 align-center">
            <v-col
              cols="12"
              class="text-center justify-center grey--text darken-2 subtitle-1">
              {{ $t('home.notAvailableYet') }}
            </v-col>
          </v-row>
        </v-col>

      </template>
    </v-row>
  </v-col>
  <!-- No Slots -->
  <v-col
    v-else
    class="text-center justify-center subtitle-1">
    {{ $t('home.noSlots') }}
  </v-col>
</template>

<script>
import { localeMixin } from '../mixins'
import { mapGetters } from 'vuex'
import { nth } from '../modules/utils'
import _ from 'lodash'
import moment from 'moment'
import momentTz from 'moment-timezone'

export default {
  mixins: [localeMixin],
  props: {
    isEmbedded: {
      type: String,
      default: null
    },
    rescheduleSlot: {
      type: Number,
      default: null
    },
    rescheduleSlotEnd: {
      type: Number,
      default: null
    },
    isSaving: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      daysList: [],
      dayFiller: [],
      possibleStartTime: [],
      slotSaving: null,
      slotSelectedStartTimestamp: 0,
      startDaysList: 0,
      timeZones: [],
      weekEndDays: ['Sat', 'Sun']

    }
  },
  computed: {
    ...mapGetters('meetings', [
      'selectedMeetingType',
      'meetingSlots'
    ]),
    currentDaysList () {
      return this.daysList.slice(this.startDaysList, this.startDaysList + this.numberSlotToDisplay)
    },
    // reduces time list to avoid slot gaps
    currentPossibleTimes () {
      let newTimeList = []
      let slotTimesUniq = _.uniq(_.map(_.flatten(_.map(this.currentDaysList, 'slots')), 'start'))
      let deleteTime = true
      for (let i = 0; i < this.possibleStartTime.length; i++) {
        if (slotTimesUniq.filter(t => this.possibleStartTime[i] === t).length > 0) {
          newTimeList.push(this.possibleStartTime[i])
          deleteTime = false
        } else if (deleteTime === false) {
          newTimeList.push(this.possibleStartTime[i])
          deleteTime = true
        }
      }
      return newTimeList
    },
    currentMonth () {
      if (this.daysList && this.daysList[this.startDaysList]) {
        return this.daysList[this.startDaysList].date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
      }
      return ''
    },
    currentMaxNbSlots () {
      return Math.max(...(this.currentDaysList.map(v => v.slots.length)))
    },
    slotToReschedule () {
      if (this.rescheduleSlot) {
        return moment.unix(this.rescheduleSlot).tz(this.selectedMeetingType.timezone)
      }
      return null
    },
    slotToRescheduleEnd () {
      if (this.rescheduleSlotEnd) {
        return moment.unix(this.rescheduleSlotEnd).tz(this.selectedMeetingType.timezone)
      }
      return null
    },
    numberSlotToDisplay () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 2
        case 'sm': return 3
        case 'md': return 4
        case 'lg': return 6
        case 'xl': return 6
      }
    }
  },

  mounted () {
    if (this.meetingSlots && this.meetingSlots.length > 0) {
      this.selectedMeetingType.originalTimezone = this.selectedMeetingType.timezone
      this.selectedMeetingType.timezone = moment.tz.guess()
      this.computeSlots()
      // timezone
      const momentTimezones = momentTz.tz.names().filter(name => name.slice(0, 4) !== 'Etc/')
      momentTimezones.forEach(tz =>
        this.timeZones.push({ hour: momentTz.tz(tz).format('HH:mm'),
          hourH12: momentTz.tz(tz).format('h:mm A'),
          tzDisplay: tz.replace('_', ' ').replace('/', ', '),
          tz: tz })
      )
      this.timeZones = _.orderBy(this.timeZones, 'hour')
    }
  },
  methods: {
    previousSlots () {
      if (this.startDaysList - this.numberSlotToDisplay < 0) {
        this.startDaysList = 0
      } else {
        this.startDaysList -= this.numberSlotToDisplay
      }
    },
    nextSlots () {
      this.startDaysList += this.numberSlotToDisplay
    },
    daySlotStartTime (daySlots, slotStartTime) {
      return daySlots.filter(slot => slot.start === slotStartTime)
    },
    isSlotSelected (slot) {
      return slot.startTimestamp === this.slotSelectedStartTimestamp
    },
    selectSlot (slot) {
      this.slotSelectedStartTimestamp = slot.startTimestamp
    },
    goToSlot (slot) {
      if (!this.isSaving) {
        this.$emit('slotSelected', slot)
        this.slotSaving = slot
      }
    },
    timezoneChange (value) {
      if (value) {
        this.computeSlots()
      }
    },
    computeSlots () {
      let minSlotTime = 23
      let maxSlotTime = 0
      const daysListTemp = []
      this.meetingSlots.map(slot => {
        slot.startTimeMoment = slot.startTime * 1000
        slot.endTimeMoment = slot.endTime * 1000
        slot.timezoneDate = moment(slot.startTimeMoment).tz(this.selectedMeetingType.timezone).format('YYYYMMDD')
      })
      let day = moment(this.meetingSlots[0].startTimeMoment).tz(this.selectedMeetingType.timezone)
      const lastDay = moment(this.meetingSlots[this.meetingSlots.length - 1].startTimeMoment).tz(this.selectedMeetingType.timezone)
      while (day.isSameOrBefore(lastDay, 'day')) {
        const dayFormatted = day.tz(this.selectedMeetingType.timezone).format('YYYYMMDD')
        const correspondingSlots = this.meetingSlots.filter(slot => slot.timezoneDate === dayFormatted)
        const slotTimes = []
        correspondingSlots.map(slot => {
          const start = moment(slot.startTimeMoment).tz(this.selectedMeetingType.timezone).format('HH:mm')
          const startH12 = moment(slot.startTimeMoment).tz(this.selectedMeetingType.timezone).format('h:mm')
          const end = moment(slot.endTimeMoment).tz(this.selectedMeetingType.timezone).format('HH:mm')
          const endH12 = moment(slot.endTimeMoment).tz(this.selectedMeetingType.timezone).format('h:mm A').toLowerCase()
          slotTimes.push({ start, end, startTimestamp: slot.startTime, endTimestamp: slot.endTime, startH12, endH12 })
        })
        // min and max to have a consistent display between days
        if (slotTimes.length > 0) {
          const maxDay = _.maxBy(slotTimes, 'start')
          const hour = parseInt(maxDay.start.slice(0, 2)) + 1
          if (hour > maxSlotTime) {
            maxSlotTime = hour
          }
          const minDay = _.minBy(slotTimes, 'start')
          const hourMin = parseInt(minDay.start.slice(0, 2))
          if (hourMin < minSlotTime) {
            minSlotTime = hourMin
          }
        }
        daysListTemp.push({ date: new Date(day.format('YYYY/MM/DD HH:mm:ss')), slots: slotTimes })
        day = day.add(1, 'days')
      }
      if (this.slotToReschedule && parseInt(this.slotToReschedule.format('HH')) < minSlotTime) {
        minSlotTime = parseInt(this.slotToReschedule.format('HH'))
      }
      if (this.slotToReschedule && parseInt(this.slotToReschedule.format('HH')) > maxSlotTime) {
        maxSlotTime = parseInt(this.slotToReschedule.format('HH'))
      }
      this.daysList = [...daysListTemp]
      // fill possible start times
      this.possibleStartTime = []
      for (let i = minSlotTime; i < maxSlotTime; i++) {
        this.possibleStartTime.push(`${('0' + i).slice(-2)}:00`)
        this.possibleStartTime.push(`${('0' + i).slice(-2)}:30`)
      }
      // day filler (to display 'no future slot available')
      this.dayFiller = []
      for (let i = 1; i < 6; i++) {
        this.dayFiller.push(new Date(lastDay.add(1, 'days').format('YYYY/MM/DD HH:mm:ss')))
      }
    },
    isRescheduledSlot (date, possibleTime) {
      if (this.slotToReschedule && this.slotToReschedule.format('HH:mm') === possibleTime) {
        const dateFormatted = `${date.getFullYear()}${date.getMonth() + 1}${date.getDate()}`
        if (dateFormatted === this.slotToReschedule.format('YYYYMD')) {
          return true
        }
      }
      return false
    },
    getNth (date) {
      return nth(date)
    }
  }
}
</script>
<style lang="scss">
.slotList {
  &__timezone {
    position: sticky;
    top:0px;
    background: white;
    z-index:1;
  }
  &__DayList {
    overflow-x: hidden;
    flex-wrap:nowrap;
    width:100%;
    &-column {
      &-date {
        &--today {
          background-color: $blue;
          border-radius: 50%;
          color: white;
        }
      }
      &--slot {
        width:100%;
        text-transform: none;
        font-size: 0.85rem !important;
        //color: $color-darkGrey4!important;
        &:hover, &:focus {
          //border-color: $blue;
          //color: $blue !important;
        }
      }
        &__weekEndDay {
          .slotList__DayList {
            &--block {
              background-color:$color-lightGrey4;
            }
            &-column {
              &-day {
                opacity: 0.5;
              }
            }
          }
        }
      &--slotReschedule {
        border-color: $blue;
        color: $blue !important;
        background-color: $blue-lighten-5;
        text-transform: none;
      }

    }
    &--block {
      cursor: default;
    }
    &--filler {
      height: calc(100% - 52px);
      background-color:$color-lightGrey4 !important;
      border-radius:4px;
    }
  }
  .noTextDetails {
    .v-text-field__details {
      display: none;
    }
  }
  .smallerBtn {
    width: 30px;
    height: 30px;
  }
}
</style>
